/* ---- Imports ---- */

import { nextTick } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import routes from './app'
import { useLoadingStore } from '@/stores/loading.js'
import { auth } from '@/firebaseConfig'
import { GA_MEASUREMENT_ID } from '@/constants/analytics'
import { trackPageView as metaTrackPageView } from '@/lib/metaPixel'

/* ---- Routes ---- */

/* ---- System ---- */

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior (to, from, savedPosition) {
    return { top: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  const loadingStore = useLoadingStore()
  

  // Auth Check
  if (to.meta.requiresAuth) {
    const user = await new Promise(resolve => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            unsubscribe();
            resolve(user);
        });
        // Timeout de segurança de 4s caso o Firebase demore
        setTimeout(() => {
          resolve(auth.currentUser);
        }, 4000);
    });

    if (user) next();
    else next('/admin/login');
  } else {
    next();
  }
})

router.afterEach((to) => {
  /* Só aplica o fallback se a rota definiu um título estático.
     Páginas que usam o composable `useSeo` gerenciam o próprio <title>
     reativo ao idioma e não devem ser sobrescritas aqui. */
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }

  /* Marketing (todas as rotas): GTM e GA4 recebem cada navegação SPA.
     Tags base carregam em index.html; sem isto, só a primeira URL seria
     atribuída corretamente. No GTM, crie um trigger para o evento
     `spa_page_view` ou use o History Change. */
  nextTick(() => {
    nextTick(() => {
      if (typeof window === 'undefined') return
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'spa_page_view',
        page_path: to.fullPath,
        page_location: window.location.href,
        page_title: document.title
      })
      if (typeof window.gtag === 'function') {
        window.gtag('config', GA_MEASUREMENT_ID, {
          page_path: to.fullPath,
          page_location: window.location.href,
          page_title: document.title
        })
      }

      /* Meta Pixel — re-dispara PageView a cada navegação SPA.
         O PageView inicial é feito pelo base code em index.html. */
      metaTrackPageView()
    })
  })
})

export default router
